import React from 'react';

import { Page, Card, DataTable } from '@shopify/polaris';
import includes from 'lodash/includes';

const DISPLAY_AMOUNT_STATUSES = ["PARTIALLY_PAID", "PENDING"];

const DisplayControlOrders = (props) => {

  let values = [];

  if (props.orders.length > 0) {
    for(let order of props.orders){
      let parsedOrder = order;
      let received_amount = null;

      if( !includes(DISPLAY_AMOUNT_STATUSES, order.financial_status)){
        parsedOrder = {
          ...parsedOrder,
          amount: "",
        }
      }
      else{
        if (parseFloat(order.received_amount) != parseFloat(order.amount)) {
          received_amount = parseFloat(order.amount) - parseFloat(order.received_amount).toFixed(2);
          parsedOrder.amount = order.amount;
        }
      }


      values.push(
        [
          parsedOrder.display_shopify_id || parsedOrder.shopify_id,
          parsedOrder.name,
          I18n.t(`shopify.order.financial_status.${parsedOrder.financial_status.toLowerCase()}`),
          received_amount,
          parsedOrder.amount,
        ]
      )
    }
  }

  return(
    <Card>
      <DataTable
        headings={[
          I18n.t("activerecord.attributes.dispatch_order.shopify_id"),
          I18n.t("activerecord.attributes.dispatch_order.name"),
          I18n.t("activerecord.attributes.dispatch_order.financial_status"),
          I18n.t("activerecord.attributes.dispatch_order.received_amount"),
          I18n.t("activerecord.attributes.dispatch_order.amount"),
        ]}
        rows={values}
        columnContentTypes={[
          'text',
          'text',
          'text',
          'text',
          'text'
        ]}/>
    </Card>
  )
}

export default DisplayControlOrders;
